import { createStyles, makeStyles } from '@material-ui/styles';
import CrossPattern from 'assets/avatar/categories/cross-pattern.png';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.background.box,
      display: 'flex',
      gap: '10px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '10px 10px 0px 0px',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: '18px',
      padding: '16px 13px 16px 13px',
      cursor: 'pointer',
      userSelect: 'none',
      transition: '0.3s',
      '&:hover': {
        transform: 'scale(1.05)'
      }
    },
    danger: {
      backgroundColor: palette.common.red,
      backgroundImage: `${palette.gradient.whiteShadow}, url(${CrossPattern})`,
      color: palette.common.white
    },
    selected: {
      zIndex: 9
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
